export interface IBusinessCardsRequest {
    micrositeRecipientId: number,
    cardBatchDateTime?: Date,
    businessCardsRequestDate?: Date,
    businessCardsRequestSize: number,
}